import { useState, useEffect, useCallback } from 'react';
import '../../utils/responsive.es.js';
import { useIsDestroyed } from '../../hooks/useIsDestroyed/useIsDestroyed.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';

const useImage = (props) => {
  const { src, crossOrigin, srcSet, sizes, onLoad, onError } = props;
  const [status, setStatus] = useState("pending");
  const isDestroyed = useIsDestroyed();
  useEffect(() => {
    setStatus(src ? "loading" : "pending");
  }, [src]);
  const loadImage = useCallback(() => {
    if (!src)
      return;
    const image = new Image();
    image.src = src;
    if (crossOrigin) {
      image.crossOrigin = crossOrigin;
    }
    if (srcSet) {
      image.srcset = srcSet;
    }
    if (sizes) {
      image.sizes = sizes;
    }
    image.onload = (event) => {
      if (isDestroyed.current)
        return;
      setStatus("loaded");
      onLoad == null ? void 0 : onLoad(event);
    };
    image.onerror = (event) => {
      if (isDestroyed.current)
        return;
      setStatus("failed");
      onError == null ? void 0 : onError(event);
    };
  }, [crossOrigin, isDestroyed, onError, onLoad, sizes, src, srcSet]);
  useEnhancedEffect(() => {
    if (status === "loading") {
      loadImage();
    }
  }, [status, loadImage]);
  return {
    isLoaded: status === "loaded",
    isFailed: status === "failed",
    isPending: status === "pending",
    isLoading: status === "loading"
  };
};

export { useImage };
//# sourceMappingURL=useImage.es.js.map
